export const slugify = (text) =>
  (text || '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

export const generateBaseSlug = (jobTitle, parish) => {
  const titleSlug = slugify(jobTitle);
  const locationSlug = slugify(parish);
  return [titleSlug, locationSlug].filter(Boolean).join('-');
};
